
<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled [appDialogMinimizable]="MinimizableDialogType.ProfileLookup">
    <mat-dialog-content (cdkDragStarted)="dialogBoundryService.handleDragStart($event)" (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)" cdkDragRootElement=".cdk-overlay-pane" cdkDrag>
        <div appDialogDragArea cdkDragHandle></div>
        <app-profile-lookup [caseId]="data.caseId" (closed)="close()"></app-profile-lookup>
      </mat-dialog-content>
</div>
